import {
 checkBinding, sendSmsValidate, validateSms, doBinding, validateSmsAndBind
} from '../../../services/personnelService/signUpService';

// initial state
// state 必為模組區域變數，取時需 store.state.auth.user
// 其他則視 default 內是否有設 namespaced = true 來決定是全域還是區域
// 區域使用時值需加上 name
const state = {};

// getters
const getters = {};

// actions
const actions = {
  // 驗證綁定狀態
  async checkBindingHandler() {
    const data = await checkBinding();
    return data;
  },
  // 傳送簡訊驗證
  async sendSmsValidateHandler({}, mobile) {
    const data = await sendSmsValidate({ mobile });
    return data;
  },
  // 驗證簡訊驗證碼
  async validateSmsHandler({}, validateInfo) {
    const data = await validateSms(validateInfo);
    return data;
  },
  // 綁定
  async doBindingHandler({}, userInfo) {
    const data = await doBinding(userInfo);
    return data;
  },
  async validateSmsAndBindHandler({}, dataInfo) {
    await validateSmsAndBind(dataInfo);
  }
};

// mutations
const mutations = {};

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations
};
